import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
import { Provider } from 'react-redux';
import "./i18n/i18n";
import store from "./redux/store";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Clients from "./pages/clients/Clients";
import Dijikolay from "./pages/integrations/dijikolay/Dijikolay";
import AddClients from "./pages/clients/components/AddClients/AddClients";
import Users from "./pages/clients/users/Users";
import AddUser from "./pages/clients/components/AddUser/AddUser";
import { useTranslation } from "react-i18next";
import trTR from 'antd/es/locale/tr_TR';
import enUS from 'antd/es/locale/en_US';
import DataWarehouse from "./pages/clients/components/DataWarehouse/DataWarehouse";

function App() {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'tr' ? trTR : enUS;

  return (
    <Provider store={store}>
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            fontFamily:
              "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          },
          components: {
            Menu: {
              itemSelectedBg: "#02B9D9",
              itemSelectedColor: "white",
            },
            Tree: {
              colorPrimary: '#02b9d9',
            },
            Select: {
              colorPrimary: '#02b9d9',
            }
          },
        }}
      >
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/add-clients"
                element={
                  <ProtectedRoute>
                    <AddClients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/view-users/:companyId"
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/add-user/:companyId"
                element={
                  <ProtectedRoute>
                    <AddUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/data-warehouse/:clientId"
                element={
                  <ProtectedRoute>
                    <DataWarehouse />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/integrations/dijikolay"
                element={
                  <ProtectedRoute>
                    <Dijikolay />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AuthProvider>

        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
}

export default App;